// The custom system has no rule entities to share: sheets are shared through
// template export/import instead. A null schema keeps it out of the
// HomebrewEditor system dropdown.
const homebrew = null;

export default homebrew;
